import React, { useEffect, useState, useRef } from "react";

import "./dashboard.css";
import { BsReverseListColumnsReverse } from "react-icons/bs";
import { capitalize } from "../../Assets/functions/work-with-strings";

const ColumnsSelector = ({
  columns,
  selectedColumns,
  changeSelectedColumns,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef(null);
  const handleClick = () => {
    if (isOpen) setIsOpen(false);
    else setIsOpen(true);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  const handleChange = (e, index) => {
    if (e.target.checked) {
      changeSelectedColumns(index, true);
    } else {
      changeSelectedColumns(index, false);
    }
  };
  return (
    <div className="relative" ref={containerRef}>
      <button
        className="border border-solid border-[var(--var-gris)] p-[10px] text-[18px] flex justify-center items-center text-black rounded-md group hover:bg-sky-500 transition-all"
        onClick={(e) => {
          e.stopPropagation();
          handleClick();
        }}
      >
        <BsReverseListColumnsReverse className="group-hover:text-white" />
        <span className="group-hover:text-white group-hover:text-[18px] ">
          Columns
        </span>
      </button>
      {isOpen && (
        <div className="transition-all">
          <div className="absolute w-0 h-0 left-[10%] border-white border-b-[11px] border-l-[10px] border-r-[10px] border-b-gray-200 bg-white top-[100%] z-50 transition-all" />
          <div className="absolute flex flex-col top-[120%] -left-5 py-4 w-[220px] bg-white z-50 all-300 rounded-xl border-2 border-gray-200 ">
            <form action="" className="flex flex-col gap-[10px]">
              {columns &&
                columns.map((it, index) => (
                  <div className="flex gap-[10px] hover:bg-sky-300 px-3">
                    <input
                      type="checkbox"
                      name={it}
                      id={it}
                      defaultChecked={selectedColumns[index]}
                      onChange={(e) => handleChange(e, index)}
                    />
                    <label htmlFor={it} className="font-md text-slate-500">
                      {capitalize(it)}
                    </label>
                  </div>
                ))}
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default ColumnsSelector;
